import { TranslationValue } from '@prenuvo/halo';

import { ServicesInfo, User } from '@/api';
import { calculateAge, isEmpty, isNotEmpty } from '@/shared/util';

import { SERVICE_DISPLAY_NAME, SERVICE_INFO_ORDER } from './header.constant';

export const calculatePatientAge = (patient: User): number | undefined =>
  isEmpty(patient?.dob) ? undefined : calculateAge(patient.dob);

export const getPatientDisplayName = (
  patient: User,
  unknownNameText: string = 'Unknown Patient Name',
) => {
  if (isNotEmpty(patient?.lastname) && isNotEmpty(patient?.firstname)) {
    return `${patient.lastname}, ${patient.firstname}`;
  }

  if (isNotEmpty(patient?.fake_lastname) && isNotEmpty(patient?.fake_firstname)) {
    return `${patient.fake_lastname}, ${patient.fake_firstname}`;
  }

  return unknownNameText;
};

export const getPatientDob = (
  patient: User,
  translate: (id?: string, values?: TranslationValue) => string | undefined,
) => translate('FCT.REPORTING.HEADER.PATIENT.DOB', { dob: patient?.dob });

export const getServiceInfoNameList = (servicesInfo: ServicesInfo[]) =>
  servicesInfo
    .slice()
    .sort((a, b) => {
      const aIndex = SERVICE_INFO_ORDER.indexOf(a.code);
      const bIndex = SERVICE_INFO_ORDER.indexOf(b.code);

      return (
        (aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex) -
        (bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex)
      );
    })
    .map((service) => SERVICE_DISPLAY_NAME[service.name] ?? service.name);
